import JobDescriptionModal from "./JobDescriptionModal";

export default JobDescriptionModal;
